import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPartialDate } from 'Utility/date';
import PlatformConditional from 'Components/PlatformConditional';

const ENMG = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'clinicalstudy.enmg'} />}
      newButton={
        <DocumentCreationButton
          name="enmg"
          text={'clinicalstudy.newenmg'}
          onClick={startEdit({}, 'enmg')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <PlatformConditional platform={['sma', 'dmd']}>
              <Item xs={2}>
                <FormattedMessage id={'general.date'} />
              </Item>
              <Item xs={6}>&nbsp;</Item>
            </PlatformConditional>
            <PlatformConditional platform={['polyneuro']}>
              <Item xs={2}>
                <FormattedMessage id={'general.date'} />
              </Item>
              <Item xs={2}>
                <FormattedMessage id="clinicalstudy.polyneuro.clinicalSubtypeClassification" />
              </Item>
              <Item xs={2}>
                <FormattedMessage id="clinicalstudy.polyneuro.pathophysiologicalClassification" />
              </Item>
              <Item xs={3}>
                <FormattedMessage id="clinicalstudy.polyneuro.conductionBlockOutsideTypicalEntrapmentSites" />
              </Item>
              <Item xs={3} />
            </PlatformConditional>
          </>
        }
        contentFormat={d => (
          <>
            <PlatformConditional platform={['sma', 'dmd']}>
              <Item xs={2} style={{ fontWeight: '600' }}>
                {formatPartialDate(d.date)}
              </Item>
              <Item xs={5}>&nbsp;</Item>
              <Item xs={2}>&nbsp;</Item>
              <Item xs={3}>
                <HistoryRowControls document={d} startEdit={startEdit} />
              </Item>
            </PlatformConditional>
            <PlatformConditional platform={['polyneuro']}>
              <Item xs={2} style={{ fontWeight: '600' }}>
                {formatPartialDate(d.date)}
              </Item>
              <Item xs={2}>
                {d.clinicalSubtypeClassification ? (
                  <FormattedMessage id={'clinicalstudy.polyneuro.opts.' + d.clinicalSubtypeClassification} />
                ) : (
                  '-'
                )}
              </Item>
              <Item xs={2}>
                {d.pathophysiologicalClassification ? (
                  <FormattedMessage id={'clinicalstudy.polyneuro.opts.' + d.pathophysiologicalClassification} />
                ) : (
                  '-'
                )}
              </Item>
              <Item xs={3}>
                {d.conductionBlockOutsideTypicalEntrapmentSites ? (
                  <FormattedMessage id={'general.' + d.conductionBlockOutsideTypicalEntrapmentSites} />
                ) : (
                  '-'
                )}
              </Item>
              <Item xs={3}>
                <HistoryRowControls document={d} startEdit={startEdit} />
              </Item>
            </PlatformConditional>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'enmg'>[];
  startEdit: StartEdit;
}

export default ENMG;
